// src/App.js
import React, { useState, useEffect } from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import ListingDetail from './components/ListingDetail';
import LoginPage from './components/LoginPage';
import AllPosts from './pages/AllPosts';
import Auta from './pages/Auta';
import Nehnutelnosti from './pages/Nehnutelnosti';
import AboutUs from './pages/AboutUs';
import ContactUs from './pages/ContactUs';
import Neplatiči from './pages/Neplatici';
import HeaderMenu from './components/HeaderMenu';
import Footer from './components/Footer';

import './styles.css';

function Layout({ children, isAdmin, onLogout }) {
  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      minHeight: '100vh' 
    }}>
      <HeaderMenu isAdmin={isAdmin} onLogout={onLogout} />
      <main style={{ flex: 1 }}>
        {children}
      </main>
      <Footer isAdmin={isAdmin} onLogout={onLogout} />
    </div>
  );
}

function App() {
  // Initialize isAdmin from localStorage immediately to avoid timing issues
  const [isAdmin, setIsAdmin] = useState(() => {
    try {
      return localStorage.getItem('isAdmin') === 'true';
    } catch (err) {
      console.error('Error reading isAdmin from localStorage:', err);
      return false;
    }
  });
  const navigate = useNavigate();
  const location = useLocation();
  const [showLoginModal, setShowLoginModal] = useState(false);

  // When user logs in successfully
  const handleLoginSuccess = () => {
    setIsAdmin(true);
    localStorage.setItem('isAdmin', 'true');
    navigate('/');
  };

  // Logout
  const handleLogout = () => {
    setIsAdmin(false);
    localStorage.removeItem('isAdmin');
    navigate('/');
  };

  // Skip layout for login page
  const isLoginPage = location.pathname === '/login';

  if (isLoginPage) {
    return (
      <Routes>
        <Route
          path="/login"
          element={<LoginPage onLoginSuccess={handleLoginSuccess} />}
        />
      </Routes>
    );
  }

  return (
    <Layout isAdmin={isAdmin} onLogout={handleLogout}>
      <Routes>
        <Route
          path="/"
          element={<Home isAdmin={isAdmin} onLogout={handleLogout} />}
        />
        <Route
          path="/listings/:id"
          element={<ListingDetail />}
        />
        <Route
          path="/all-posts"
          element={<AllPosts isAdmin={isAdmin} onLogout={handleLogout} />}
        />
        <Route
          path="/allposts"
          element={<AllPosts isAdmin={isAdmin} onLogout={handleLogout} />}
        />
        <Route
          path="/auta"
          element={<Auta isAdmin={isAdmin} onLogout={handleLogout} />}
        />
        <Route
          path="/auta/page/:pageNumber"
          element={<Auta isAdmin={isAdmin} onLogout={handleLogout} />}
        />
        <Route
          path="/nehnutelnosti"
          element={<Nehnutelnosti isAdmin={isAdmin} onLogout={handleLogout} />}
        />
        <Route
          path="/nehnutelnosti/page/:pageNumber"
          element={<Nehnutelnosti isAdmin={isAdmin} onLogout={handleLogout} />}
        />
        <Route
          path="/neplatici"
          element={<Neplatiči isAdmin={isAdmin} onLogout={handleLogout} />}
        />
        <Route
          path="/neplatici/page/:pageNumber"
          element={<Neplatiči isAdmin={isAdmin} onLogout={handleLogout} />}
        />
        <Route
          path="/about-us"
          element={<AboutUs isAdmin={isAdmin} onLogout={handleLogout} />}
        />
        <Route
          path="/contact"
          element={<ContactUs isAdmin={isAdmin} onLogout={handleLogout} />}
        />
      </Routes>
    </Layout>
  );
}

export default App;
